var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"loading":!_vm.showIframePdf,"tile":"","elevation":"0"}},[_c('v-card-text',[(_vm.showIframePdf)?_c('iframe',{staticClass:"iframe-custom",attrs:{"src":this.pdfPage,"frameborder":"0","scrolling":"no","allowfullscreen":""}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }